export default "__VITE_PUBLIC_ASSET__173a6c3d__"